<template>
  <div :class="['header', bgc ? 'bgc' : '']">
    <van-icon name="arrow-left" @click="goBack(back)" v-if="disabled"></van-icon>
    <slot></slot>
  </div>
</template>

<script>
import { reactive, toRefs } from '@vue/reactivity'
import { useRouter, useRoute } from 'vue-router'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    bgc: {
      type: Boolean,
      default: false
    },
    back: {
      type: Number,
      default: 0
    }
  },
  components: {
  },
  setup(props) {
    const router = useRouter()
    const state = reactive({
    })

    const goBack = (back) => {
      if(back == 1) {
        router.push('/profile')
      } else if (back == 2) {
        router.push('/store')
      } else {
        router.back()
      }
    }

    return {
      ...toRefs(state),
      goBack
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    height: 2.5rem;
    font-size: 1.125rem;
    color: var(--cl);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
    // max-width: 640px;
    background: linear-gradient(to right, var(--bc3), var(--bc4));
    &.bgc {
      background: var(--cl);
      color: var(--c3);
    }
    i {
      width: 2.5rem;
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0;
    }
  }
</style>